import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2, // 2 min — données considérées fraîches
      gcTime: 1000 * 60 * 10, // 10 min — conservé en cache après unmount
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});
